var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerformance = function SvgPerformance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 0c5.404 0 9.676 4.19 9.7 9.653l.006.088c.044.755-.042 1.748-.358 2.898-.473 1.72-1.375 3.427-2.802 5.027l-.298.334H3.752l-.298-.334c-1.427-1.6-2.33-3.306-2.802-5.027C.336 11.489.25 10.496.294 9.74L.3 9.653C.324 4.19 4.596 0 10 0Zm0 2C5.679 2 2.3 5.325 2.3 9.7l-.006.11-.003.048c-.032.547.035 1.324.29 2.251.36 1.315 1.029 2.63 2.077 3.891h10.684c1.048-1.262 1.716-2.576 2.077-3.89.255-.928.322-1.705.29-2.252l-.003-.048-.006-.11C17.7 5.325 14.321 2 10 2Zm4.695 3.305a1 1 0 0 1 .012 1.402l-1.856 1.857a3 3 0 1 1-1.236-1.592l1.678-1.679a1 1 0 0 1 1.402.012ZM10 8.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  })));
};
export default SvgPerformance;